<template>
    <!--hint内容 -->
  <div class="hint_container">
    温馨提示：您可以点击您想了解的问题进行查询，也可以直接下拉查询您想要了解的内容.
  </div>
</template>

<script>
    export default {
        name: "Hint",
        data() {
            return {}
        },
        methods: {}
    }
</script>

<style scoped>
.hint_container{
  margin-top: 10px;
  width:92%;
  display: inline-block;
  padding-left: 18px;
  font-size: 13px;
  color: #999999;
  letter-spacing: 0;
  text-align: left;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/hint.vue